<af-main-container
    [title]="(isEdit ? 'i18n_lib_breadcrumb#EditDocument' : 'i18n_af_createKnowledgeDocumentTitle') | translate : {id: response?.name}"
    [showBackButton]="true"
    [tabPathToTab]="tabPathToTab"
    [buttonSpinnerId]="'save'"
    filterNavigationPath="edit-document"
    [breadcrumbCustomizer]="this.documentId ? breadcrumbCustomizer : undefined"
    (buttonClickListener)="save()">
    @if (form) {
        <form class="w-100 bc-mono-white radius-16 p-24 mt-24" [formGroup]="form"
              fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="24px">

            <af-dictionary-selector class="w-400"
                                    [dictionaryName]="ReferenceBookType.KNOWLEDGE_BASE_DOCS"
                                    [control]="form.controls.type"
                                    label="i18n_af_labelType"
                                    placeholder="i18n_af_placeholderSelectDocumentType"/>

            <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelDocumentName' | translate }}*</div>
                <mat-form-field class="mt-4 w-100"
                                [class.value-not-empty]="form.controls.name.value">
                    <input matInput
                           #nameInput
                           [maxlength]="150"
                           [placeholder]="'i18n_af_placeholderDocumentName' | translate"
                           [formControl]="form.controls.name"/>
                    <mat-hint align="start" class="t5 c-primary-gray-600">
                        {{
                            'i18n_af_hintMaxLength' | translate: {
                                current: nameInput.value.length,
                                max: 150
                            }
                        }}
                    </mat-hint>
                </mat-form-field>
            </div>

            @if (isDocumentType) {
                <af-file [hasType]="false"
                         dropzoneMode="button"
                         [documentAttachment]="response?.attachedDocument"
                         [bucket]="BucketName.KNOWLEDGE_BASE_FILES"
                         [mimeTypes]="KB_MIME_TYPES"
                         [multiple]="false"
                         [downloadable]="isEdit"
                         [form]="form.controls.attachment"/>
            }

            @if (isLinkType) {
                <div fxLayout="column" fxLayoutAlign="start start" class="w-824">
                    <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelLink' | translate }}*</div>
                    <mat-form-field class="mt-4 w-100"
                                    [class.value-not-empty]="form.controls.link.value">
                        <input matInput
                               [placeholder]="'i18n_af_placeholderLink' | translate"
                               [formControl]="form.controls.link"/>
                    </mat-form-field>
                </div>
            }

            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
                <ui-kit-button spinnerId="save"
                               [disabled]="form.invalid"
                               [label]="(isEdit ? 'i18n_af_buttonSave' : 'i18n_af_buttonAdd') | translate"
                               (clickListener)="save()"/>
                <ui-kit-button color="accent"
                               buttonType="button"
                               type="text"
                               (clickListener)="navigateBack()"
                               [label]="'i18n_af_buttonCancel' | translate"/>
            </div>
        </form>
    }
</af-main-container>
